<div class="locations">
	<status-list
		*ngIf="includeCompanyStatusRow"
		[statusItems]="companyStatusItems"
	></status-list>
	<div class="location" *ngFor="let loc of locationsToDisplay">
		<div class="location-text" [ngClass]="{ 'no-margin': !useSeparator }">
			<div *ngIf="isUpdateScreen && featureSwitches.enableShowLocations">
				<span class="location-text-bold">{{ loc.city }}</span
				>&nbsp;
				<span *ngIf="loc.city !== loc.name">({{ loc.name }})</span>
			</div>
			<div *ngIf="!isUpdateScreen && featureSwitches.enableShowLocations">
				<div *ngIf="singleLine">
					{{ getLocationDisplayValue(loc) }}
				</div>
				<div *ngIf="!singleLine">
					<div>{{ loc.name }}</div>
					<div *ngIf="loc.city !== loc.name" class="city">
						{{ loc.city }}
					</div>
				</div>
			</div>
			<div
				*ngIf="showSeparator && featureSwitches.enableShowLocations"
				class="separator"
				[ngClass]="{ narrowScreen: narrowScreen }"
			></div>
			<status-list [statusItems]="statusItems(loc)"></status-list>
		</div>
	</div>
</div>
